export const convertHtmlToText = (passHtmlBlock: HTMLElement) => {
  return passHtmlBlock.toString().replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, '')
}
